<template>
<!-- Una pagina dedicata alla normativa -->
  <div>
    <PageTagline :elements="tagline_elem"/>

    <!-- Tutorial contestuale per gli argomenti del form. Vengono passati gli slug name dei video da mostrare -->
    <TutorialContestuale :video_to_show="['area_informazioni']"/>

    <!-- CARD PER CONTENERE LA PGINA -->
    <b-card no-body class="mr-1 ml-1">
      <b-card-header>
        <h4><font-awesome-icon icon="info-circle" size="lg"/> Normativa</h4>
      </b-card-header>
      <b-card-body>
        <b-row class="mb-3">
            <b-col>
              <h4>Cos'è il Welfare Aziendale</h4>
              <p>È un modo per corrispondere al lavoratore una serie di benefit di utilità concreta, senza che questi concorrano alla formazione del reddito.</p>
              <h4>Come funziona</h4>
              <p>Lo strumento per erogare welfare è la piattaforma web, denominata Welfarebit, che consente all’utente di scegliere tra una vasta gamma di beni e servizi, tutti previsti dalla normativa vigente come esenti da tasse e contributi.
                 La normativa di riferimento del mondo Welfare è costituita dal Testo Unico Delle Imposte Sui Redditi (T.U.I.R.) e, nel dettaglio, dagli articoli 51 e 100.
                 Riportiamo, a titolo di esempio, una sintesi visiva delle principali voci di spesa ammissibili:</p>
            </b-col>
        </b-row>
        <!-- Dovendo solo visulizzare dati semplici e statici usiamo la versione lite della tabella con meno feature -->
        <b-table-lite stacked="md"
                :items="datatable.items"
                :fields="datatable.fields">
        </b-table-lite>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import TutorialContestuale from '@/components/TutorialContestuale'

export default {
  name: 'NormativaView',
  data () {
    return {
      // Variabili generali
      tagline_elem : [ { text : "Normativa", link : 'normativa' } ],

      // Elementi della tabella
      datatable : {
        // Definizione delle colonne da visualizzare
        fields: [
            {
              key: 'tipo_spesa',
              label: 'Tipologia di spesa',
            },
            {
              key: 'tipo_richiesta',
              label: 'Tipologia di richiesta'
            }
        ],
        // Elementi da mostrate nella tabella
        items : [
            { tipo_spesa : "Spese rette asilo nido", tipo_richiesta : "Rimborso" },
            { tipo_spesa : "Spese rette scuola materna", tipo_richiesta : "Rimborso" },
            { tipo_spesa : "Spese rette da scuola primaria fino ad università", tipo_richiesta : "Rimborso" },
            { tipo_spesa : "Spese per frequentazione campus estivi", tipo_richiesta : "Rimborso" },
            { tipo_spesa : "Spese per acquisto testi scolastici", tipo_richiesta : "Rimborso" },
            { tipo_spesa : "Assistenza sanitaria integrativa", tipo_richiesta : "Pagamento aziendale fino a 3615,20€" },
            { tipo_spesa : "Interessi su prestiti / mutui", tipo_richiesta : "Rimborso" },
            { tipo_spesa : "Previdenza integrativa", tipo_richiesta : "Pagamento aziendale fino a 5300€" },
            { tipo_spesa : "Beni e servizi in natura", tipo_richiesta : "Pagamento aziendale fino ad euro 1000€ per la generalità dei lavoratori e 2000€ per i lavoratori con figli a carico" },
            { tipo_spesa : "Spese assistenza (es. baby sitter e badanti)", tipo_richiesta : "Rimborso per badante o pagamento aziendale per baby sitter" },
            { tipo_spesa : "Spese di ricreazione (viaggi, teatro, ecc...)", tipo_richiesta : "Pagamento aziendale" },
            { tipo_spesa : "Spese per attività sportive", tipo_richiesta : "Pagamento aziendale" },
        ]
      }
    }
  },
  components : {
    PageTagline,
    TutorialContestuale
  }
}
</script>

<style scoped></style>
